export const styles = {
  screenContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "safe center",
    justifyContent: "safe center",
    height: "100%",
    flex: 1,
    gap: "52px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  onboardingAvatar: {
    height: "202px",
  },
  onboardingControls: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: "15px",
  },
  nextButton: {
    borderRadius: "25px",
    padding: "14px 28px",
    fontSize: "16px",
    lineHeight: "24px",
  },
  textLinkBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    lineHeight: "21px",
    color: "events.blueSecondary",
    "&:hover": {
      color: "events.blueSecondary",
    },
    padding: "0 2px",
    height: "auto",
    width: "auto",
    backgroundColor: "transparent",
  },
  takeMeToEvent: {
    textTransform: "none",
  },
  nextButtonIcon: {
    ml: 1,
  },
  heading: {
    fontSize: "20px",
    lineHeight: "22px",
    color: "text.primary",
    fontWeight: 500,
    textAlign: "center",
    px: 2,
    maxWidth: "340px",
  },
};
